import React from 'react'
import { Link } from 'react-router-dom'
import './foot2.css'

function Foot2() {
  return (
    <div className='foot2'>
      <div className="top"><input type="text" value= ' Disabled' disabled /><button>Search</button></div>
      <div className="foot2sections mid">Sections: &nbsp;<Link to="/">politics (1)</Link> &nbsp;<Link to="/">   business autos (1)</Link>&nbsp;<Link to="/"> jobs (1)</Link>&nbsp;<Link to="/"> career education (1) </Link>&nbsp;<Link to="/">romance</Link>&nbsp;<Link to="/"> computers </Link> &nbsp;<Link to="/">phones</Link>&nbsp;<Link to="/"> travel </Link>&nbsp;<Link to="/"> sports </Link>&nbsp;<Link to="/"> fashion </Link>&nbsp;<Link to="/"> health </Link> &nbsp;<Link to="/"> religion </Link>&nbsp;<Link to="/"> celeb </Link> &nbsp;<Link to="/">tv-movie</Link><Link to="/">music-radio</Link>&nbsp;<Link to="/">literature</Link>&nbsp;<Link to="/">webmasters</Link>&nbsp;<Link to="/">programming</Link>&nbsp;<Link to="/">techmarket</Link></div>
       <div className="bottom mid">
       Links: (1) (2) (3) (4) (5) (6) (7) (8) (9) (10)
      </div>
      <div className="mid"><span><Link to="g.g">Nairaland</Link></span> - Copywrite &copy; 2005 - 2022 &nbsp;<Link to="g.g"> Oluwaseun Osewa</Link>. All rights reserved. See &nbsp; <Link to="g.g"> How To Advertise</Link>. 1</div>
      <div className="bottom"><h4>Disclaimer</h4>: Every Nairaland member is <h4>&nbsp;solely responsible&nbsp;</h4> for <h4>&nbsp;anything&nbsp;</h4> that he or she <h4>&nbsp;posts&nbsp; </h4>or <h4>&nbsp;uploads&nbsp; </h4> on Nairaland.</div>
         <h4 className="owner">Built and Designed by Olawale @ <a href="snotat.com">snotat.com</a> </h4>
     
    </div>
  )
}

export default Foot2